import { Component, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BehfaRole_Interface, Empty_BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BehfaRoleService } from 'src/app/Service/BehfaRole/BehfaRole.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-BehfaRoleAdd',
  templateUrl: './BehfaRoleAdd.component.html',
  styleUrls: ['./BehfaRoleAdd.component.scss']
})
export class BehfaRoleAddComponent implements OnInit {

  Title:string=""
  Token:String=""
  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>Type your text here...</p>'
  };
  public config = {
    language: 'fa'
  };

  constructor(
    private Alertify_Service:AlertifyService,
    private BehfaRole_Service:BehfaRoleService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');


    this.Nav_Service.CheckValidPage(this.Token,1105).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }


  InProccessing:boolean=false
  onSubmitForm(){

    if(!this.Title)
    {
      this.Alertify_Service.ErrorMessage("Please enter a title")
    }
    else{
      var Record:BehfaRole_Interface=Empty_BehfaRole_Interface()
      Record.title=this.Title
      Record.dsc=this.model.editorData

      this.InProccessing=true
      this.BehfaRole_Service.AddBehfaRole(Record,this.Token).subscribe(
        data=>{
          this.model.editorData='<p>Type your text here...</p>'
          this.Title=""
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.InProccessing=false
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )

    }

  }

}
